"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodesByNet = void 0;
const network_1 = require("./network");
// Add hard-coded nodes here
exports.nodesByNet = {
    [network_1.Network.MainNet]: [
        {
            nodeId: "shadowmainnet1",
            rpcUrl: "https://shadow-tm-api.carbon.network/",
            wsUrl: "wss://shadow-ws-api.carbon.network/ws",
            faucetUrl: "",
            insightsUrl: "https://api-insights.carbon.network",
            restUrl: "https://shadow-api.carbon.network",
            moniker: "Shadow Mainnet 1",
            appBuild: "mainnet",
            lastupdated: "2022-01-03T03:56:10.190Z",
            rpcUptime: "0",
            wsUptime: "0",
            insightUptime: "100",
            tmWsUrl: "wss://shadow-tm-api.carbon.network/",
            grpcWebUrl: "",
            appCommit: "",
            appVersion: "",
            creator: {
                name: "",
                telegram: "",
                email: "",
            },
            latestBlockHeight: 0,
        },
        {
            nodeId: "shadowmainnet2",
            rpcUrl: "http://18.139.169.234:26657",
            wsUrl: "ws://18.139.169.234:5000/ws",
            faucetUrl: "",
            insightsUrl: "https://api-insights.carbon.network",
            restUrl: "http://18.139.169.234:1317",
            moniker: "Shadow Mainnet 2",
            appBuild: "mainnet",
            lastupdated: "2022-01-03T03:56:10.190Z",
            rpcUptime: "0",
            wsUptime: "0",
            insightUptime: "100",
            tmWsUrl: "wss://shadow-tm-api.carbon.network/",
            grpcWebUrl: "",
            appCommit: "",
            appVersion: "",
            creator: {
                name: "",
                telegram: "",
                email: "",
            },
            latestBlockHeight: 0,
        },
    ],
    [network_1.Network.DevNet]: [
        {
            nodeId: "devnetlatest",
            rpcUrl: "https://dev39911-tm-api.carbon.network",
            wsUrl: "wss://dev39911-ws-api.carbon.network/ws",
            faucetUrl: "",
            insightsUrl: "https://api-insights.carbon.network",
            restUrl: "https://dev39911-api.carbon.network",
            moniker: "Devnet Latest",
            appBuild: "devnet",
            lastupdated: "2022-01-17T10:00:00.190Z",
            rpcUptime: "0",
            wsUptime: "0",
            insightUptime: "100",
            tmWsUrl: "wss://dev39911-tm-api.carbon.network/",
            grpcWebUrl: "",
            appCommit: "",
            appVersion: "",
            creator: {
                name: "",
                telegram: "",
                email: "",
            },
            latestBlockHeight: 0,
        },
    ],
};
